import PropTypes from "prop-types"
import React from "react"

useHandleMessageFromChildFrame.propTypes = {
  callback: PropTypes.func.isRequired,
  params: PropTypes.shape({
    messageType: PropTypes.string.isRequired,
  }),
}

export function useHandleMessageFromChildFrame(callback, { messageType }) {
  React.useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) return
      if (event.data.type !== messageType) return

      callback(event)
    }

    window.addEventListener("message", handleMessage)

    return () => {
      window.removeEventListener("message", handleMessage)
    }
  }, [callback, messageType])
}
